module.exports = __webpack_public_path__ + "static/media/splash1_3x.25c5c6ff.jpg";